"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCloseMenuOnEscape = useCloseMenuOnEscape;
var _react = require("react");
function useCloseMenuOnEscape(_ref) {
  var isDialogOpen = _ref.isDialogOpen,
    closeDialog = _ref.closeDialog;
  (0, _react.useEffect)(function () {
    if (!isDialogOpen) {
      return;
    }
    function keyDownHandler(e) {
      if (isDialogOpen && e.key === 'Escape') {
        e.preventDefault();
        closeDialog();
      }
    }
    document.addEventListener('keydown', keyDownHandler);
    return function () {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [isDialogOpen]);
}